// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2BZLq","productName":"Table_productName__1ND7l"};